import axios from "axios";
const version = "v1";
const apiVms = "https://api-dev.kinesismonetary.com" + version;

const baseAPIVMS = axios.create({
    baseURL: apiVms,
    headers: {
        "Content-Type": "application/json",
        'Authorization': "Bearer " + sessionStorage.getItem("token_vms"),
    },
});

export default baseAPIVMS